import {
  BUSINESS_HOURS,
  EMAIL,
  LOGIN_ROUTE,
  PHONE,
  PHONE_LINK_SUPPORT,
  PHONE_SUPPORT,
  URL_PRIVACY,
  URL_TERMS_CONDITIONS,
} from 'utils/constants';

const es = {
  error: {
    generic: '',
    routerBanner:
      'Esta ruta es insegura. Un desarrollador debe añadir esta pantalla a la función "isRouteAvailableAccordingtoBE" del componente "Router"',
  },

  common: {
    continue: 'continuar',
    confirm: 'confirmar',
    currencySymbol: '€',
    download: 'descargar',
    back: 'volver',
    currency: 'EUR',
    skip: 'omitir',
    loan_overview: '',
    loan: '',
    term: '',
    days: 'días',
    days_one: 'día',
    days_other: 'días',
    hours_one: 'hora',
    hours_other: 'horas',
    minutes_one: 'minuto',
    minutes_other: 'minutos',
    seconds_one: 'segundo',
    seconds_other: 'segundos',
    interest: 'interés',
    apr: '',
    goBack: 'Volver',
    interest_rate: '',
    logout: 'Cerrar sesión',
    edit: 'editar',
    retry: '',
    show_more: 'mostrar más',
    show_less: '',
    months: 'meses',
    contactPhone: PHONE,
    contactEmail: EMAIL,
    businessHours: BUSINESS_HOURS,
    termsAndConditionsText: 'Términos y condiciones',
    termsAndConditionsUrl: URL_TERMS_CONDITIONS,
    calculator: {
      confirmChanges: 'CONFIRMAR CAMBIOS',
      openLoanInformationModal: 'INFORMACIÓN SOBRE EL PRÉSTAMO',
      title: 'Edita tu solicitud',
      swiperQuantity: 'Elige la cantidad',
      swiperTerm: 'Elige el plazo',
    },
  },

  bankAccount: {
    cardGreenMsg1: 'El IBAN no es el número de tu tarjeta bancaria',
    cardGreenMsg2:
      'Puedes encontrar tu número de cuenta IBAN en tu banca online y copiarlo desde allí',
    cardGreenMsg3:
      'Si no encuentras tu número de IBAN, contacta con tu banco y pide ayuda',
    cardHelper: 'Ejemplo:',
    cardGreenTitle: 'Tu cuenta bancaria',
    continueBtn: 'Continuar',
    error:
      'El número introducido contiene errores. Si necesitas ayuda, contacta con nosotros {{phoneNumber}}.',
    subtitle:
      'Necesitamos tu cuenta bancaria para enviarte el dinero cuando tu préstamo sea aprobado.',
    title: 'Tu cuenta bancaria',
    questionLink: '¿Qué es el IBAN?',
    modalTitle: '¿Qué es el IBAN?',
    modalText:
      '<p>Las siglas IBAN (International Bank Account Number) significan Código Internacional de Cuenta Bancaria en español.</p>\n<p>El IBAN <strong>llegó en 2014 para sustituir al desaparecido CCC</strong>, que se correspondía con las siglas Código Cuenta Cliente y hace referencia a los veinte dígitos que identificaban a las cuentas corrientes bancarias en nuestro país.</p>\n<p>Con la intención de <strong>homogeneizar las operaciones bancarias entre los países de la zona euro</strong> nació el IBAN que sirve para identificar nuestras cuentas bancarias. La composición del IBAN es alfanumérica  y la forman 24 caracteres. La explicamos:</p>\n<ol>\n<li>Los cuatro primeros caracteres son <strong>dos letras que identifican al país</strong> (en España, ES) y dos números que son un código de control.</li>\n<li>Los cuatro siguientes son <strong>números que identifican a la entidad bancaria.</strong></li>\n<li>Cuatro números más que hacen referencia al <strong>código de la sucursal.</strong></li>\n<li>Por último, <strong>doce números hasta completar los 24</strong> que forman el IBAN.</li>\n</ol>\n<p>Por ejemplo: ES00 1111 2222 333333333333</p>\n<p>En realidad el IBAN es exactamente igual al ya extinto CCC pero anteponiéndole el código alfanumérico ESXX en el caso de España, donde XX son los dígitos de control.</p>\n<p>Puedes encontrar tu número de IBAN en <strong>los detalles de tu cuenta en el servicio de banca online</strong> de tu banco.</p>',
  },

  dates: {
    friday: 'Viernes',
    monday: 'Lunes',
    nationalHolidays: 'Festivos nacionales',
    thursday: 'Jueves',
    tuesday: 'Martes',
    saturday: 'Sábado',
    sunday: 'Domingo',
    wednesday: 'Miércoles',
  },

  notification: {
    400: 'Petición malformada, intentalo de nuevo',
    401: 'Se requiere autorización',
    403: 'No tienes permisos para realizar esa operación',
    405: 'Método no permitido',
    407: 'Se requiere autenticación de proxy',
    408: 'El servidor se agotó esperando el resto de la petición del navegador',
    418: 'Soy una tetera',
    500: 'Error del servidor',
    999: 'Te has retrasado 7 días en el pago. Por favor, contacta con nosotros si estás teniendo dificultades para devolver el préstamo',
    too_young: `La edad mínima permitida es de 21 años`,
    too_old: `La edad máxima permitida es de 79 años`,
    default: 'Oops! Algo ha ido mal!',
    defaultTryItLater: 'Oops! Algo ha ido mal. Por favor, intentelo mas tarde',
    TypeError: 'Oops! Algo ha ido mal!',
    fileSize: 'Tamaño del archivo excedido (25 MB máximo por archivo)',
    wrongEmailPhone: 'Correo o teléfono incorrecto',
    genericRegistrationError:
      'Ha habido un problema con su registro, por favor, póngase en contacto con soporte',
    GenericError:
      'Ha habido un problema con su registro, por favor, póngase en contacto con soporte',
    loginRegistrationError: {
      title: '¿No te deja seguir? Es posible que ya tengas una cuenta:',
      text: 'Prueba a entrar en el <a href="{{login}}">área de clientes</a> y reestablece tu contraseña si es necesario. Si sigues teniendo problemas llámanos al  <a href="tel:{{phone-no-spaces}}">{{phone}}</a>',
    },
    REJECTED_CREDIT_LIMIT_REACHED:
      'Debes tener al menos 25 años para solicitar un préstamo con esa cantidad. Por favor, reduce el importe del préstamo',
    ageRestriction: {
      title:
        'Hemos ajustado el importe de tu préstamo a un máximo de {{creditLimit}} €',
    },
    already_exists_in_db:
      'Ha habido un problema con su registro, por favor, póngase en contacto con soporte',
    Forbidden:
      'Ha surgido un problema. Por favor, ponte en contacto con nosotros en el teléfono <a href="tel:{{phone-no-spaces}}">{{phone}}</a>',
    incorrect_format:
      'Hay un campo con un formato incorrecto, por favor, revisa los cambios',
    incorrect_web_code:
      'Código incorrecto. Por favor, introduce el código de nuevo',
    invalid_credentials:
      'Credenciales incorrectos. Por favor, compruébalo de nuevo',
    not_allowed_to_update:
      'No tienes suficientes permisos para actualizar. Por favor, póngase en contacto con soporte',
    resend_not_allowed: 'No se ha permitido realizar el reenvío',
    Unauthorized: 'Se requiere autorización',
    same_phone: `El número que has introducido es idéntico al anterior. <a href="/first-loan/phone-verification">Solicita un código nuevo</a>, introduce un número diferente o llama al ${PHONE_SUPPORT}`,
    same_phone_incorrect_code:
      'El número de teléfono que has introducido es idéntico al anterior. Por favor, introduce un número de teléfono diferente para cambiarlo, solicita un código nuevo o llama al 912 90 77 88 para finalizar tu solicitud',
    phone_already_exists: `Este número de teléfono no es válido. Introduce un número diferente o llama al ${PHONE_SUPPORT} para finalizar tu solicitud`,
    can_not_finish_registration:
      'No hemos podido completar tu registro. Por favor llámanos al 912 90 77 88 para finalizarlo',
    web_code_verification_attempts_exceeded: `Se han realizado demasiados intentos. <br>Por favor, llama al ${PHONE_SUPPORT} para finalizar tu solicitud`,
    web_code_resend_attempts_exceeded: `Se han realizado demasiados intentos. <br>Por favor, llama al ${PHONE_SUPPORT} para finalizar tu solicitud`,
    validation: {
      Account_number_already_is_used_by_another_client: {
        bankAccountNumber:
          'Ha habido un problema con su registro, por favor, póngase en contacto con soporte',
      },
      already_exists_in_db: {
        email:
          'Ha habido un problema con su registro, por favor, póngase en contacto con soporte',
        personalId: `Si ya eres cliente entra en tu <a href=${LOGIN_ROUTE}>área de cliente</a>.`,
        bankAccountNumber: 'Número de IBAN no válido, intenta con otro número',
      },
      incorrect_format: {
        personalId: 'ID está en un formato incorrecto',
      },
      too_old: {
        dateOfBirth: `La edad máxima permitida es de 79 años`,
      },
    },
    login_unavailable: `Ha surgido un problema.<br />Por favor, ponte en contacto con nosotros en el teléfono <strong><a href="tel:${PHONE_LINK_SUPPORT}">${PHONE_SUPPORT}</a></strong>.`,
    best_offer_error:
      'Ha habido un error obteniendo la oferta. Por favor, inténtalo de nuevo mas tarde',
  },
  paylandFailed: {
    body: `Puedes intentarlo de nuevo en unos minutos o utilizar otra tarjeta. Si tienes preguntas llámanos al  <strong><a href="tel:${PHONE_LINK_SUPPORT}">${PHONE_SUPPORT}</a></strong>.`,
    title: 'Lo sentimos, el registro de la tarjeta ha fallado',
    primaryBtn: 'CONTINUAR',
  },

  paymentSuccess: {
    bodyTitle: 'Una vez procesado el pago:',
    bodyOption1: '- Recibirás confirmación vía SMS (en unos minutos)',
    bodyOption2:
      '- Actualizaremos la información de tu préstamo en tu área de cliente',
    bodyOption3:
      'Si has seleccionado el cargo automático, en la nueva fecha de vencimiento cargaremos el pago de tu préstamo.',
    primaryBtn: 'ENTENDIDO',
    title: 'Pago en proceso',
  },

  progress: {
    intro: 'Empieza tu solicitud',
    identification: 'Regístrate',
    confirmation: 'Identifícate',
    summary: 'Recibe tu dinero',
  },

  login: {
    title: '¡Bienvenido!',
    login: 'login',
    forgotPassword: '¿Has olvidado la contraseña?',
    fields: {
      id: { label: 'ID' },
      password: { label: 'Password' },
    },
    idPlaceholder: 'Email o DNI/NIE',
    passwordPlaceholder: 'Contraseña',
    forgottenPassword: '¿Has olvidado tu contraseña?',
    submit: 'Accede a tu área personal',
    errors: {
      wrong_credentials:
        'Email, DNI/NIE o contraseña incorrectos. Por favor, comprueba tus datos e inténtalo de nuevo.',
    },
  },

  welcome: {
    title: '¡Hola de nuevo!',
    subtitle:
      'Tienes una solicitud sin terminar. Termina el proceso para conseguir tu préstamo.',
    tableTitle: 'Datos de tu préstamo',
    continueButtonText: 'Continuar',
    table: {
      row1: 'Importe solicitado',
      row2: 'Intereses',
      row3: 'Total a devolver',
      row4: 'Fecha de devolución',
    },
  },

  registration_header: {
    error_content_modal:
      '<div>Ha habido un error. Por favor, inténtalo mas tarde</div>',
    title_amount: 'Elige la cantidad que quieras',
    title_days: 'Elige los dias que necesitas para el aplazamiento',
    title_modal: 'Información sobre el préstamo',
  },

  registration_rejected: {
    backBtn: 'Volver a la portada',
    messageGreen:
      'Lo sentimos, en este momento no podemos ofrecerte un préstamo',
    messageSecondary:
      'Si tu situación personal cambia en el futuro, puedes volver a contactar con nosotros para conseguir la financiación que necesites.',
    messageStrong: 'No es un "no" para siempre',
    title: 'Solicitud denegada',
  },

  registration_loading: {
    title: 'Comprobando tu información',
    subtitle:
      'Por favor, no cierres la ventana todavía. Este proceso puede tardar unos minutos.',
  },

  registration_success: {
    activateBtn: 'ACTIVAR',
    agreedBtn: 'ENTENDIDO',
    messageGreen:
      'Te llamaremos lo antes posible para confirmar algunos datos una vez sean revisados tus documentos. Te comunicaremos el resultado de tu solicitud en esta misma llamada',
    messageSecondCard:
      'No haremos ningún cargo en tu tarjeta hasta que llegue la fecha de pago de tu préstamo',
    title: 'Ya casi estamos',
    titleMessageGreen: '¡No te separes de tu móvil!',
    titleMessageSecondCard:
      '¡Activa el pago automático y paga de forma cómoda y segura!',
  },

  register_upload_documentation: {
    formatError: 'El formato o tamaño del archivo no es válido',
    btnAdditionalDocument: 'Documentos adicionales',
    btnBack: 'Volver',
    btnContinue: 'CONTINUAR',
    errorUploadMessage:
      'Tamaño máximo permitido: 25 MB, en formato JPG, PNG, BMP, GIF, HEIC, HEIF o PDF',
    warningMessage:
      'Tamaño máximo permitido: <strong>25 MB</strong>, en formato JPG, PNG, BMP, GIF, HEIC, HEIF o PDF',
    modalBtnContinue: 'CONTINUAR',
    modalTitle: 'COMPRUEBA:',
    modalLine1: '¿La foto es nítida y legible?',
    modalLine2: '¿Muestra el documento completo?',
    modalLine3: '¿Está hecha sobre un fondo neutro?',
    option1: 'Parte delantera DNI / NIE',
    option2: 'Parte trasera DNI / NIE',
    option3: 'Justificante bancario reciente a tu nombre',
    option3_warning:
      '<strong>Importante:</strong> no adjuntes tu tarjeta bancaria por temas de seguridad',
    additional_documents: 'Otros documentos (NIE, Pasaporte, etc.)',
    secured: 'Seguro',
    subtitle_manual:
      'Necesitamos verificar tu identidad y comprobar los datos de un justificante bancario reciente.',
    subtitle_online:
      '¡Casi estamos! Debido a un fallo de Tink necesitamos una foto de ambas caras de tu <b>DNI o NIE</b> y un <b>justificante bancario reciente.</b>',
    title: 'Subir documentación',
    documentTypes: {
      frontSideDni: 'DNI (parte frontal)',
      backSideDni: 'DNI (parte trasera)',
      bankReceipt: 'Recibo bancario',
      idCard: 'Tarjeta de identificación',
      passport: 'Pasaporte',
      gunLicense: 'Licencia de armas',
      driversLicense: 'Licencia de conducir',
      photo: 'Foto',
      otherDocument: 'Otro documento',
      incomeDocument: 'Documento de ingreso',
    },
    modalNewDocument: {
      title: '¿Qué tipo de documento desea subir?',
      selectPlaceholder: 'Seleccione tipo de documento.',
      submitBtn: 'CONTINUAR',
      titleSecondStep: 'Subir ',
      selectFile: 'SELECCIONAR ARCHIVO',
    },
  },

  summary: {
    title: 'Resumen',
    amount: 'Importe',
    duration: 'Plazo',
    interest: 'Intereses',
    repayable_amount: 'Total a devolver',
    repayment_date: 'Fecha de devolución',
    edit: 'EDITAR SOLICITUD',
    secured: 'Confianza asegurada',
  },
  first_loan_docs_required_tinkFailed: {
    title: 'Documentación requerida',
    subtitle:
      '¡Casi estamos! Debido a un fallo de Tink necesitamos una foto de ambas caras de tu <strong>DNI o NIE</strong> y un <strong>justificante bancario reciente.</strong>',
  },
  first_loan_documents_required: {
    title: 'Documentación adicional requerida',
    subtitle:
      'Para terminar tu solicitud, necesitamos recibir una foto o copia de tu <strong>DNI o NIE</strong> y un <strong>justificante bancario reciente.</strong>',
  },

  requestDenied: {
    backBtn: 'Volver a la portada',
    messageGreen:
      'Lo sentimos, en este momento no podemos ofrecerte un préstamo',
    messageSecondary:
      'Si tu situación personal cambia en el futuro, puedes volver a contactar con nosotros para conseguir la financiación que necesites.',
    messageStrong: 'No es un "no" para siempre',
    title: 'Solicitud denegada',
    frequentCausesTitle: 'Las causas más frecuentes de denegación son',
    frequentCauses: [
      'Un histórico de impago con nosotros en el pasado.',
      'Estar incluido en un fichero de morosidad.',
      'Tener otro crédito abierto actualmente con nosotros.',
    ],
  },

  introduction_list_sections: {
    point1: 'Garantiza tu pago en la fecha correcta',
    point2: 'Gana tiempo para cosas que amas',
    point3: 'Control total con notificaciones de tus transacciones',
    point4: 'Genera mejores condiciones para tus próximos préstamos',
  },

  introduction: {
    title: 'Solicita tu primer préstamo',
    sessionTitle: '¿Ya eres cliente?:',
    sessionLink: 'Inicia sesión',
    requestTitle: 'Requisitos:',
    speedupTitle: 'Para agilizarlo:',
    continueButtonText: 'EMPEZAR',
    idText: 'Residir en España y tener DNI o NIE en vigor',
    adultText: 'Ser mayor de edad',
    ownerAccountText: 'Ser titular de una cuenta bancaria española',
    bankText: 'Registra tu tarjeta bancaria y activa el pago automático',
    bankTextMoreInfo: 'Más información',
    modalBankHeading: '¿Cómo funciona Tink?',
    youtubeVideoPlayer: 'Reproductor de vídeo de YouTube',
    bankIdentification: 'Identificarte con tu banco online',
    modalBankText:
      'Tink es una empresa segura que opera de forma internacional y se encarga de gestionar la identificación, acceso y estado de cuentas de un usuario dentro de cualquier servicio de banca online, sin necesidad de realizar envíos de documentación y agilizando los trámites a la hora de solicitar un microcrédito.<br /><br />Tink funciona de manera sencilla, comparando y comprobando los datos en tu banco. Lo único que tienes que hacer es iniciar sesión y automáticamente se realizará la comprobación necesaria para la solicitud de tu microcrédito.<br /><br />Puedes estar tranquilo/a, porque los datos del usuario se tratan con total confidencialidad y están seguros en todo momento.<br /><br />Echa un vistazo a este vídeo para entender todos los pasos de manera sencilla.',
    modalBankCard: {
      title: 'REGISTRA TU TARJETA BANCARIA',
      description:
        'Para hacer tu experiencia con nosotros aún más cómoda y sin preocupaciones, estamos emocionados de presentarte nuestro utilidad de pago automático.<br /><br />Registrar su tarjeta bancaria es simple: una vez comiences el proceso de identificación te pediremos que agregues los detalles de tu tarjeta bancaria de forma segura utilizando nuestra encriptación de última generación. Podrás disfrutar de tu crédito a los pocos minutos.',
      listTitle: 'Beneficios increíbles',
      listSection: [],
    },
    modalBankBody: {
      agreedButton: 'ENTENDIDO',
      banks: [],
      point1:
        'Solicitaremos tu consentimiento para conectar una sola vez con tu Banco',
      point2:
        'Introduce las credenciales de acceso a tu cuenta Bancaria online de manera 100% segura',
      point3:
        'Después de la verificación de tu identidad, cerraremos complemente el acceso momentáneo a tu cuenta Bancaria.',
      video: 'Ver vídeo paso a paso',
      header2: 'Bancos admitidos',
    },
    modalAgreeBtn: 'entendido',
    userTitle: '¿Ya has tenido un préstamo Vivus?',
    userDescription: `Entra en tu área de cliente para ver las opciones disponibles`,
    userLink: 'Ir a mi área de cliente',
  },
  identification: {
    agreements: {
      firstAgreement: `Consiento recibir publicidad personalizada de VIVUS FINANCIAL SERVICES S.A.U., las empresas del Grupo VIVUS y terceros colaboradores, sobre descuentos, promociones, ofertas y novedades (<marketing>más información</marketing>).`,
      secondAgreement: `Consiento que VIVUS FINANCIAL SERVICES S.A.U. comunique mis datos a sus partners para que me informen, en base a mi perfil, sobre sus productos o servicios (<communications>más información</communications>).`,
      thirdAgreement:
        'He leído y acepto los <terms>Términos y Condiciones</terms>, la <privacy>Política de Privacidad</privacy> y la <onClickLink>Información Normalizada Europea</onClickLink>. Así mismo, declaro estar informado/a de que un micropréstamo es una categoría específica de préstamos, caracterizada por solicitudes de cantidades pequeñas a corto plazo, y que el coste de Vivus  es igual o inferior a la media según los datos publicados por <cesco>CESCO</cesco>. <bold>Lectura y aceptación obligatoria.</bold>',
      fourthAgreement:
        'Consiento que Tink recoja, utilice y transfiera mi información bancaria, incluyendo transacciones a VIVUS a través de su servicio.',
    },
    title: 'Datos de contacto',
    emailPlaceholder: 'E-mail',
    phonePlaceholder: 'Teléfono móvil',
    continueButtonText: 'CONTINUAR',
    selectAll: 'Seleccionar todos',
    details:
      'Puedes estar tranquilo/a, en Vivus.es utilizamos la última tecnología para mantener tus datos encriptados y protegidos.',
    additionalInfo: `VIVUS tratará tus datos para gestionar tu registro legitimado en la correcta ejecución de los servicios solicitados. En caso de otorgar tu consentimiento, tratará tus datos para informarte de nuestros productos, y de los de nuestros partners. Más información en <a target="_blank" href=${URL_PRIVACY} >Política de Privacidad</a>. Delegado de Protección de Datos: <a href="mailto:dpd@vivus.es">dpd@vivus.es</a>.`,
  },

  confirmation: {
    title: 'Crear tu cuenta',
    idInputLabel: 'Ejemplo: 12345678A/X1234567B',
    idPlaceholder: 'Número de DNI / NIE',
    passwordInputLabel:
      'La contraseña debe contener al menos 8 carácteres, letras y números o carácteres especiales.',
    passwordPlaceholder: 'Contraseña',
    continueButtonText: 'CREAR TU CUENTA',
    details:
      'Puedes estar tranquilo/a, en Vivus.es utilizamos la última tecnología para mantener tus datos encriptados y protegidos.',
  },

  phoneVerification: {
    heading: 'Verifica tu teléfono',
    subheading: 'Introduce el código SMS que te hemos enviado al ',
    resend_code:
      'Si necesitas recibir otro código, haz click <onClickLink>aquí</onClickLink>',
    error_message: 'Código incorrecto.',
    change_phone_text_1:
      'Si tu teléfono no es {{clientPhone}}, haz click <onClickLink>aquí</onClickLink>',
    here: 'aquí ',
    spam_folder:
      'Recuerda revisar tu carpeta SPAM.<br/><onClickLink>Más información</onClickLink>',
    time_remaining:
      'Si necesitas recibir otro código, debes esperar <onClickLink>{{time}}</onClickLink>',
    phone_change_time_remaining:
      'Para cambiar el teléfono debes esperar {{time}}',
    submit_button: 'Continuar',
  },

  incorrectCode: {
    heading: 'Código incorrecto',
    subheading:
      'Introduce tu número de móvil correcto para recibir un código nuevo.',
    mobile_phone: 'Teléfono móvil',
    continue_button: 'Continuar',
  },

  phoneChange: {
    heading: 'Cambiar el número de teléfono',
    subheading:
      'Introduce tu número de móvil correcto para recibir un código nuevo.',
    mobile_phone: 'Teléfono móvil',
    continue_button: 'Continuar',
  },

  personalData: {
    title: 'Datos personales',
    subtitleHeading: 'Importante',
    subtitleText:
      'Introduce los datos tal y como aparecen en tu documento de identidad.',
    firstName: 'Nombre completo',
    firstSurname: 'Primer apellido',
    secondSurname: 'Segundo apellido',
    surnameCheckbox: 'No tengo segundo apellido',
    birthdate: 'Fecha de nacimiento',
    birthdateDayPlaceholder: 'DD',
    birthdateMonthPaceholder: 'MM',
    birthdateYearPlaceholder: 'AAAA',
    birthdateDescription:
      'Necesitamos saber tu edad para asegurarnos de que cumples los requisitos para solicitar el préstamo.',
    birthdateFieldGroupLabelText: 'Fecha de nacimiento',
    continueButtonText: 'Continuar',
  },

  addressDetails: {
    title: 'Tu dirección',
    addressPlaceholder: 'Nombre de la Calle, Avenida, Plaza...',
    addressNumberPlaceholder: 'Número',
    addressFloorPlaceholder: 'Piso',
    addressLetterPlaceholder: 'Puerta/Letra',
    addressPortal: 'Bloque, Portal, Escalera...',
    addressPostalCodePlaceholder: 'Código Postal',
    addressProvincePlaceholder: 'Provincia',
    addressCityPlaceholder: 'Ciudad',
    continueButtonText: 'Continuar',
  },

  incomeDetails: {
    title: 'Tus ingresos',
    incomeSourcePlaceholder: 'Fuente de ingresos',
    avgIncomeSourcePlaceholder: 'Ingresos medios mensuales',
    description: 'Es posible que solicitemos un justificante',
    continueButtonText: 'Continuar',
    employment_status: {
      HOUSEWIFE: 'Ama de casa',
      STUDENT: 'Estudiante',
      NON_PROFIT: 'Empleado de la ONCE',
      MERCHANT: 'Venta ambulante',
      AGRICULTURE: 'Empleado sector agrario',
      PERMANENT_CONTRACT_PUBLIC: 'Contrato fijo (público)',
      TERM_CONTRACT_PUBLIC: 'Contrato temporal (público)',
      PERMANENT_CONTRACT_PRIVATE: 'Contrato fijo (privado)',
      TERM_CONTRACT_PRIVATE: 'Contrato temporal (privado)',
      PRE_RETIRED: 'Prejubilado',
      RETIRED: 'Jubilado',
      PENSIONER: 'Pensionista',
      UNEMPLOYED_GAINING_SUPPORT: 'Desempleado con prestación',
      UNEMPLOYED_CHARGING_PROVISION: 'Desempleado sin prestación',
      SELF_EMPLOYED: 'Autónomo',
      MILITARY: 'Militar, policía, guardia civil',
    },
  },

  activePayment: {
    activateBtn: 'ACTIVAR',
    message:
      'No haremos ningún cargo en tu tarjeta hasta que llegue la fecha de pago de tu préstamo',
    title: '¡Activa el pago automático y paga de forma cómoda y segura!',
  },
  online_bank_identification_waiting: {
    title: 'Comprobando tu información',
    subtitle:
      'Por favor espere, no cierre esta ventana.Este proceso puede tardar hasta 5 minutos.',
    submit_btn: 'Continuar',
  },
  online_bank_identification_bank_connection: {
    continue_button: 'CONTINUAR',
    helper_first_part: 'Si no tienes banco online, haz click',
    helper_click_part: 'aquí',
    infoTitle: 'Información sobre el servicio de identificación',
    infoBody:
      'El servicio de identificación se realiza a través de Tink, líder europeo en open banking. </br> </br> Tink se conectará con tu banco online para extraer el número de cuenta bancaria al que transferiremos automáticamente el dinero. Si eres titular de varias cuentas, el dinero será transferido a la principal, la cual se determina según el número de titulares, ingresos y transacciones. <br /> <br /> Tink verifica tu identifidad para evitar suplantaciones.',
    step1: 'Selecciona tu banco',
    step2: 'Inicia sesión',
    step3: '¡Identificado!',
    title: 'Conéctate a tu banco online',
  },
  online_bank_identification_loan_approved: {
    agreedBtn: 'Ir mi área personal',
    activeBtn: 'ACTIVAR',
    cardLine1: 'Recibirás el dinero en la cuenta',
    cardLine2: 'En los próximos',
    cardLine3:
      'Te hemos enviado vía <strong>E-mail</strong> y <strong>SMS</strong> la documentación de tu préstamo.',
    cardLine4: 'Si tienes alguna duda, llámanos al <strong>{phone}</strong>',
    title:
      '<strong>Dinero en camino</strong><br /><span>¡Tu préstamo ha sido aprobado!</span>',
    descriptionActiveCard:
      'No haremos ningún cargo en tu tarjeta hasta que llegue la fecha de pago de tu préstamo',
    titleActiveCard:
      '¡Activa el pago automático y paga de forma cómoda y segura!',
  },
  tink_verification: {
    check_points: {
      banks: '<a>Tink</a> facilita soluciones a más de 300 bancos y entidades',
      connection: 'Conexión segura con tu banco',
      european_bank: 'Tink está regulado por el Banco Central Europeo',
    },
    helper_first_part: 'Si no tienes banco online, haz click',
    helper_click_part: 'aquí',
    info_box: {
      security:
        '- Tink utiliza la seguridad de tu propio banco y conecta solo una vez para confirmar tu identidad sin realizar ninguna operación bancaria',
      transfer: '- El dinero será transferido a tu cuenta principal',
    },
    title: 'Verifica tu identidad con <a>Tink</a>',
    submit_btn: 'Verificar mi identidad',
    submit_footer:
      'Conforme a la Política de Privacidad y Términos y Condiciones aceptados previamente, Tink recogerá, y transferirá a VIVUS información bancaria, incluyendo transacciones, como parte del proceso de concesión de tu préstamo. Ver <privacy>Política de Privacidad de VIVUS</privacy>',
    warning_card: '¡Quedan menos de 2 minutos para terminar tu solicitud!',
    warning_footer_description:
      'Tink se conectará con tu banco online para extraer el número de cuenta bancaria al que transferimos automáticamente el dinero. Si eres titular de varias cuentas, el dinero será transferido a la principal, la cual se determina según el número de titulares, ingresos y transacciones.',
    youtubeVideoPlayer: 'Reproductor de vídeo de YouTube',
  },
  tink_verification_v2: {
    check_points: {
      banks:
        'Introduce tus claves bancarias conectando de forma segura con tu banco',
      connection:
        '<onClickLink>Tink</onClickLink> nos permite verificar tu identidad y poder evaluar tu capacidad crediticia',
      remember:
        'Recuerda indicar la cuenta principal donde recibes tus ingresos',
    },
    helper_first_part: 'Si no tienes banco online, haz click',
    helper_click_part: 'aquí',
    title: 'Verifica tus datos con <b>Tink</b>',
    submit_btn: 'conectar con tink',
    submit_footer:
      'Conforme a la Política de Privacidad y Términos y Condiciones aceptados previamente, Tink recogerá, y transferirá a VIVUS información bancaria, incluyendo transacciones, como parte del proceso de concesión de tu préstamo. Ver <strong><privacy>Política de Privacidad de VIVUS</privacy></strong>',
    warning_card: '¡Quedan menos de 2 minutos para terminar!',
    warning_footer_description:
      'Tink se conectará con tu banco online para extraer el número de cuenta bancaria al que transferimos automáticamente el dinero. Si eres titular de varias cuentas, el dinero será transferido a la principal, la cual se determina según el número de titulares, ingresos y transacciones.',
    youtubeVideoPlayer: 'Reproductor de vídeo de YouTube',
  },
  tink_close_modal: {
    title: '¿Ha surgido algún problema durante la identificación con TINK?',
    subtitle:
      'También puedes identificarte subiendo tu documentación manualmente',
    btn_documents: 'SUBIR DOCUMENTACIÓN',
    btn_later_hint: 'Si no tienes tus documentos a mano:',
    btn_later: 'LO HARÉ MÁS TARDE',
    retry_hint: 'O si lo prefieres, puedes',
    retry_link: 'intentar de nuevo',
  },
  tink_credentials_failed_modal: {
    title: '¿Tienes problemas con tus credenciales bancarias?',
    subtitle:
      'También puedes identificarte subiendo tu documentación manualmente',
    btn_documents: 'SUBIR DOCUMENTACIÓN',
    btn_later_hint: 'Si no tienes tus documentos a mano:',
    btn_later: 'LO HARÉ MÁS TARDE',
    retry_hint: 'O si lo prefieres, puedes',
    retry_link: 'intentar de nuevo',
  },
  online_bank_identification_manual_approved: {
    activeBtn: 'ACTIVAR',
    agreedBtn: 'ENTENDIDO',
    cardBody: 'En el caso de aprobación, recibirás el dinero en la cuenta:',
    cardSubtitle:
      'Comunicaremos el resultado de tu solicitud vía <strong>E-mail</strong> o <strong>SMS</strong> lo antes posible',
    cardTitle: 'Nuestro equipo tiene que confirmar un par de datos',
    descriptionActiveCard:
      'No haremos ningún cargo en tu tarjeta hasta que llegue la fecha de pago de tu préstamo',
    titleActiveCard:
      '¡Activa el pago automático y paga de forma cómoda y segura!',
    title: 'Casi estamos',
  },
  online_bank_identification_errorCode: {
    title: 'Lo sentimos',
    cardText: 'Algo ha ido mal. Por favor, intenta de nuevo en unos minutos.',
    buttonText: 'Inténtalo de nuevo',
  },
  online_bank_identification_rejected: {
    title: 'Resultado no concluyente',
    cardTitle:
      'No hemos podido tomar una decisión con los datos de tu cuenta bancaria.',
    option1Text:
      'No hemos podido tomar una decisión con los datos de tu cuenta bancaria.',
    option1Label: 'Opción 1',
    option2Label: 'Opción 2',
    option1:
      'Conecta a otro banco online acuérdate de utilizar la cuenta que usas más a menudo',
    option2Text: 'Llámanos al',
    buttonText: 'Conecta a otro banco',
    phone: PHONE,
  },
  loan_approved: {
    callout: {
      title: 'Tiempo aproximado para recibir\nel dinero en tu cuenta',
      description:
        'Por favor, revisa el <strong>SMS</strong> y el <strong>E-mail</strong> que te hemos\nenviado donde podrás encontrar la documentación\nrelativa a tu crédito.',
      bank_account_transaction: 'El dinero será transferido a esta cuenta:',
    },
  },

  affiliatesRepeatedLoanConfirm: {
    bankAccount: 'Cuenta bancaria',
    bankAccountHelper:
      'Si has cambiado de cuenta o quieres recibir el dinero en otra, por favor, contacta con nosotros llamando al {phone} antes de confirmar tu solicitud',
    checkTerms: `He leído y acepto los <terms>Términos y condiciones</terms> y la <onClickLink>Información Europea Normalizada del Contrato</onClickLink>`,
    confirmBtn: 'CONFIRMAR SOLICITUD',
    table: {
      row1: 'Plazo',
      row2: 'Pago mensual&nbsp <span>|</span>&nbsp<a href="payment">Ver plan de pago</a>',
      row3: 'Total a devolver',
      row4: 'Importe solicitado',
      row5: 'Intereses',
      row6: 'Fecha de última pago',
    },
    title: 'Revisa y confirma tu solicitud',
  },
  affiliatesRepeatedLoanRejected: {
    agreedBtn: 'ENTENDIDO',
    title: 'Lo sentimos, en este momento no podemos ofrecerte un préstamo',
    msg1: 'Las causas más frecuentes por las que no somos capaces de ofrecerte un préstamo son:<br />Haber tenido algún impago con nosotros en el pasado; Estar incluido en ficheros de morosidad;<br />Tener algún otro crédito abierto en estos momentos.',
    msg2Strong: '<strong>Seguimos en contacto</strong>',
    msg3: 'Nos gustaría poder ofrecerte un crédito en el futuro, por lo que no dejes de contactar de nuevo con nosotros pasado un tiempo.',
  },
  affiliatesRepeatedLoanSuccess: {
    agreedBtn: 'Ir mi área personal',
    helperBankAccount: 'El dinero será transferido a esta cuenta:',
    helperNotification:
      'Por favor, revisa el <strong>SMS</strong> y el <strong>E-mail</strong> que te hemos enviado donde podrás encontrar la documentación relativa a tu crédito.',
    cardTitle: 'Tiempo aproximado para recibir el dinero en tu cuenta',
    title:
      '<strong>Dinero en camino</strong><br /><span>¡Tu préstamo ha sido aprobado!</span>',
  },
  affiliates: {
    firstapplication: {
      title: 'Bienvenido a Vivus.es',
      title_mobile: `¡Tu préstamo de {{amount}}€ ha sido preaprobado!`,
      header: 'Has sido redirigido a <b>VIVUS</b>',
      sub_title: 'Hemos pre-aprobado tu solicitud',
      table: {
        title: 'Datos de tu préstamo',
        amount_request: 'Importe solicitado',
        interests: 'Intereses',
        return_total: 'Total a devolver',
        return_date: 'Fecha de devolución',
        footer:
          'Esta no es una aprobación definitiva. La aprobación final está sujeta a la confirmación de tus datos.',
      },
      continue: {
        title: '¿Por qué continuar ahora?',
        point1:
          'Estas a dos pasos de conseguir tu préstamo de {{amount}}€ libre de comisiones',
        point2: 'Aprobación rápida, normalmente en pocos minutos',
        point3: 'Solicitud 100% segura',
        excellent: 'Excelente',
      },
      consents_title: 'Confirma y recibe tus {{amount}}€',
      authorization_company:
        'Acepto recibir información sobre descuentos, promociones, ofertas especiales y novedades de VIVUS FINANCIAL SERVICES S.A.U. y las empresas del Grupo <a target="_blank" href="https://www.vivus.es/condiciones/marketing-y-comunicacion">(más información sobre tratamiento de datos)</a>.',
      authorization_me:
        'Autorizo a que mis datos personales sean comunicados a partners con los que VIVUS FINANCIAL SERVICES S.A.U. hayan alcanzado acuerdos, para que puedan informarme sobre sus productos o servicio <a target="_blank" href="https://www.vivus.es/condiciones/comunicaciones-a-terceros">(más información)</a>.',
      terms_condition:
        'He leído y acepto los <terms>Términos y Condiciones</terms>, la <privacy>Política de Privacidad</privacy> y la <onClickLink>Información Europea Normalizada del Contrato</onClickLink>. Lectura y aceptación obligatoria.',
      button: 'continuar',
      button_sub_title: '¿Necesitas cambiar los detalles de tu préstamo?',
      faq: {
        header_left: '¿Necesitas más claridad?',
        header_right:
          '¿Tienes más preguntas? <onClickLink>Visita nuestra sección</onClickLink>',
        items_vivus: [
          {
            question:
              '¿Has solicitado un préstamo Vivus y ahora necesitas más dinero?',
            answer:
              '<p>Puedes ampliar el importe en cualquier momento desde tu Área de Cliente Vivus, siempre que tu límite de crédito lo permita.<br /><br />¿Cómo funciona?</p><ol><li>Primer préstamo: tu límite de crédito inicial es de 300€ (si tienes 24 años o más). Solo podrás pedir un importe adicional si el importe que has solicitado inicialmente es <b>igual o inferior a 250 €</b>, ya que la cantidad mínima de importe adicional es de 50€.<br />Por ejemplo, si pediste <b>150 €</b>, podrás añadir hasta <b>150 €</b> más. Si pediste más de 250 €, <b>ya no podrás realizar ampliaciones.</b></li><li>Préstamos posteriores: tu límite de crédito aumenta progresivamente según tu historial de pagos, hasta un máximo de 1.400 €. Por ejemplo, si tu límite actual es de 800 € y pediste 300 €, podrás pedir un importe adicional de hasta 500€.</li></ol><p>Importante: aunque amplíes el importe, la fecha de vencimiento sigue siendo la misma.<br />Puedes solicitar ampliaciones tantas veces como quieras, siempre dentro de tu límite de crédito. Por ejemplo, si tu límite es de 1.000 € y pediste 500 €, puedes añadir los otros 500 € de una sola vez o repartido en varias ampliaciones, como mejor te convenga.</p>',
          },
          {
            question:
              '¿Para solicitar un primer préstamo tengo que enviar documentación?',
            answer:
              '<p> Para tu primer préstamo, realiza la identificación automática a través de Tink para no tener que enviar documentación. Este método permite conocer de inmediato si tu solicitud es aprobada.</p><p>En caso de que se produzca algún error en la verificación con Tink, podrás completar el proceso mediante identificación manual, enviando:</p><ol><li>Foto de las partes delantera y trasera de tu DNI/NIE.</li><li>Justificante bancario con los datos de la cuenta y el titular de la misma (por ejemplo, el certificado de titularidad).</li></ol>',
          },
          {
            question: '¿El primer crédito es completamente gratis?',
            answer:
              '<p>El primer préstamo de hasta 300€ es sin intereses ni comisiones, por lo que es completamente gratuito. Por ejemplo: Si solicitas un préstamo de 300€ a devolver en 30 días, solamente tendrás que devolver 300€ transcurridos los 30 días. Así de fácil.<p>',
          },
        ],
        items_vivusonline: [
          {
            question:
              '¿Has solicitado un préstamo Vivus y ahora necesitas más dinero?',
            answer:
              '<p>Puedes ampliar el importe en cualquier momento desde tu Área de Cliente Vivus, siempre que tu límite de crédito lo permita.<br /><br />¿Cómo funciona?</p><ol><li>Primer préstamo: tu límite de crédito inicial es de 300€ (si tienes 24 años o más). Solo podrás pedir un importe adicional si el importe que has solicitado inicialmente es <b>igual o inferior a 250 €</b>, ya que la cantidad mínima de importe adicional es de 50€.<br />Por ejemplo, si pediste <b>150 €</b>, podrás añadir hasta <b>150 €</b> más. Si pediste más de 250 €, <b>ya no podrás realizar ampliaciones.</b></li><li>Préstamos posteriores: tu límite de crédito aumenta progresivamente según tu historial de pagos, hasta un máximo de 1.400 €. Por ejemplo, si tu límite actual es de 800 € y pediste 300 €, podrás pedir un importe adicional de hasta 500€.</li></ol><p>Importante: aunque amplíes el importe, la fecha de vencimiento sigue siendo la misma.<br />Puedes solicitar ampliaciones tantas veces como quieras, siempre dentro de tu límite de crédito. Por ejemplo, si tu límite es de 1.000 € y pediste 500 €, puedes añadir los otros 500 € de una sola vez o repartido en varias ampliaciones, como mejor te convenga.</p>',
          },
          {
            question:
              '¿Para solicitar un primer préstamo tengo que enviar documentación?',
            answer:
              '<p> Para tu primer préstamo, realiza la identificación automática a través de Tink para no tener que enviar documentación. Este método permite conocer de inmediato si tu solicitud es aprobada.</p><p>En caso de que se produzca algún error en la verificación con Tink, podrás completar el proceso mediante identificación manual, enviando:</p><ol><li>Foto de las partes delantera y trasera de tu DNI/NIE.</li><li>Justificante bancario con los datos de la cuenta y el titular de la misma (por ejemplo, el certificado de titularidad).</li></ol>',
          },
          {
            question: '¿Cuál es el coste del primer crédito?',
            answer:
              '<p>El primer préstamo de hasta 300€ a devolver en 61 días tiene un coste de 79€. Por ejemplo: Si solicitas un préstamo de 300€ a devolver en 61 días, solamente tendrás que devolver 379€ transcurridos los 61 días. Así de fácil.<p>',
          },
        ],
      },
      modal: {
        title: '¿Necesitas más dinero?',
        items_vivus: {
          text: 'Al ser tu primer préstamo, tu límite de crédito inicial es de 300 € sin intereses.<br />Si necesitas más dinero, puedes solicitar una ampliación desde tu <b>Área de Cliente</b> Vivus, siempre que tu límite de crédito actual lo permita.<br />Además, a medida que devuelvas tus préstamos puntualmente, tu límite de crédito irá aumentando progresivamente hasta alcanzar un máximo de 1.400 €.',
        },
        items_vivusonline: {
          text: 'Al ser tu primer préstamo, tu límite de crédito inicial es de 300 €.<br />Si necesitas más dinero, puedes solicitar una ampliación desde tu <b>Área de Cliente</b> Vivus, siempre que tu límite de crédito actual lo permita.<br />Además, a medida que devuelvas tus préstamos puntualmente, tu límite de crédito irá aumentando progresivamente hasta alcanzar un máximo de 1.400 €.',
        },
        button: 'OK',
      },
      selectAll: 'seleccionar todos',
      footerBusiness: 'Horario de atención:',
      footer: '¿Prefieres hablar con alguien?',
    },
  },
  notFound: {
    title: 'La página no fue encontrada..',
    subtitle:
      'Algo ha salido mal. Lamentablemente, la página a la que quiere acceder no existe.',
    buttonText: 'Volver a casa',
  },
  bestOffer: {
    currency: '€',
    title: 'Oferta personalizada',
    description:
      'Gracias a los datos que nos has facilitado, hemos podido generar una oferta que se ajusta a tus necesidades ',
    card: {
      request: 'Solicitaste',
      offer: 'Podemos ofrecer',
      table: {
        row1: 'Plazo',
        row1TermValue: '{{term}}',
        row2: 'Importe solicitado',
        row3: 'Intereses',
        row4: 'Total a devolver',
        row5: 'Fecha de devolución',
      },
    },
    consents_link: 'Información Normalizada Europea del Crédito.',
    submitBtn: 'Confirmar',
    footer: {
      title: '¿Cómo se ha calculado el importe de mi préstamo?',
      description: `En línea con nuestra política de financiación responsable, hemos analizado tus datos detenidamente para calcular el importe idóneo para tu primer préstamo Vivus. El importe máximo disponible para tus siguientes préstamos podrá aumentar siempre y cuando, entre otras variables, se mantenga un buen comportamiento de pago. Si tienes alguna consulta no dudes en contactar con nosotros <a href="tel:${PHONE_LINK_SUPPORT}">${PHONE_SUPPORT}</a> o mail <a href="mailto:${EMAIL}">${EMAIL}</a>`,
    },
    legal_terms: 'Información sobre el préstamo',
  },
  validation: {
    wrong_format_dni: 'Dni tiene un formato incorrecto',
    wrong_format_email: 'Email tiene un formato incorrecto',
    numbers_and_letters: 'Debe contener letras y números',
    required_field: 'Campo obligatorio.',
    required_portal: 'Campo obligatorio',
    wrong_domain: 'Dominio muy corto',
    wrong_format: 'Formato incorrecto.',
    wrong_number_address_format:
      'Formato incorrecto. Se permite: número, sn o número+"bis"',
    wrong_floor_address_format:
      'Formato incorrecto. Se permite: número o "bajo"',
    wrong_door_address_format:
      'Formato incorrecto. Se permite: número o numero+letra',
    too_short: 'Muy corto.',
    too_long: 'Muy largo.',
    weak_password:
      'Se requiere un mínimo de 8 carácteres, un número o carácter especial (!@#%&*), una minúscula y una mayúscula.',
    wrong_code: 'Código incorrecto.',
    wrong_date: 'Fecha no válida.',
    agreement_required:
      'La lectura y aceptación de los Términos y Condiciones, la Política de Privacidad, y la Información Normalizada Europea son requisitos imprescindibles para la contratación de tu préstamo',
  },
  approved: {
    title: '¡Préstamo aprobado!',
    subtitle:
      'Tu préstamo de <bolder>{{amount}}€</bolder> estará en la cuenta terminada en ****{{last4DigitsAccount}} en <bolder>15 minutos.</bolder>',
    subcard: {
      title:
        'Para finalizar, registra tu tarjeta bancaria y activa el pago automático:',
      submitBtn: 'CONTINUAR',
      description:
        '¡Di adios a los intereses de demora y disfruta de ventajas increíbles!',
    },
    footer: 'Confianza asegurada',
  },
  tinkToolbar: {
    helpCard: {
      title: '¿Necesitas ayuda?',
      content:
        '¿No encuentras tu banco?¿No sabes que hacer o no puedes introducir tus credenciales?',
    },
    helpCardDetail: {
      title: 'Sentimos los problemas experimentados',
      content:
        'Entendemos que es frustrante no poder avanzar por causas ajenas. Para poder ayudarte a terminar tu solicitud, por favor, indícanos el problema que estás experimentando:',
      bankCard: 'Mi banco no está en la lista',
      credentialsCard: 'No puedo introducir mis credenciales / me da error',
      close: 'cerrar',
    },
  },
  tinkBankNA: {
    title: 'Mi banco no está en la lista',
    docCard: {
      content:
        'Lamentablemente tu banco no está disponible en estos momentos. Para continuar con tu solicitud te damos la posibilidad de subir tu documentación.',
      cto: 'Subir documentación',
    },
    laterCard: {
      title: '¿No tienes tus documentos a mano?',
      content:
        '¡Sin problema! Puedes entrar en tu área de clientes (con tu DNI / NIE o email y la contraseña que acabas de crear) más tarde para subir tus documentos.',
      cto: 'Lo haré más tarde',
    },
    footer:
      'O puedes intentar de nuevo con otra entidad. Si el problema persiste, recomendamos que subas tu documentación haciendo clic en el botón arriba.',
    footerLink: 'Intentar de nuevo',
  },
  tinkBankIssue: {
    title: 'Hay un problema conectando con tu banco',
    docCard: {
      content:
        'Puedes intentar de nuevo con otra entidad. Si el problema persiste, recomendamos que subas tu documentación haciendo clic en el botón debajo:',
      ctoDoc: 'Subir documentación',
      ctoRetry: 'Intentar de nuevo',
    },
    laterCard: {
      title: '¿No tienes tus documentos a mano?',
      content:
        '¡Sin problema! Puedes entrar en tu área de clientes (con tu DNI / NIE o email y la contraseña que acabas de crear) más tarde para subir tus documentos.',
      cto: 'Lo haré más tarde',
    },
  },
  tinkLater: {
    title: 'Sesión guardada:',
    content:
      'Cuando tengas tu documentación a mano (una copia de tu DNI / NIE y un justificante bancario), entra en tu área de clientes y sigue donde lo dejaste.',
    countTitle: 'Adjúntanos tu documentación antes de que tu solicitud expire:',
    cto: 'SUBIR DOCUMENTACIÓN',
    ctoSecondary: 'INTENTAR DE NUEVO EN TINK',
  },
  countdown: {
    hours: 'h',
    minutes: 'm',
    seconds: 's',
  },
  uploadCard: {
    remove: 'Eliminar',
    searchFile: 'Seleccionar archivo',
  },
  rejectedTimer: {
    title: 'En estos momentos no puedes solicitar un préstamo',
    desc: 'Podrás intentarlo de nuevo dentro de:',
    no_timer: 'Te avisaremos cuando sea posible cursar una nueva solicitud',
    cto: 'entendido',
  },
  otp_modal: {
    description: 'Para revisarlo:',
    title:
      'Puede que los SMS estén llegando a tu bandeja de mensajes no deseados (SPAM)',
    android_app: 'En Android:',
    ios_app: 'En iOS:',
    android_points: {
      1: 'Abre la app de Mensajes',
      2: 'Pulsa en los tres puntos verticales',
      3: 'Pulsa en Spam y bloqueado',
    },
    ios_points: {
      one: 'Ve a Ajustes del sistema',
      2: 'Selecciona la app Mensajes',
      third: 'Activa la opción Filtrar desconocidos',
    },
    cto: 'entendido',
  },
  stelo: {
    top_notif: '¡Último paso!',
    title: 'Conecta con la Seguridad Social',
    approved: {
      bullet1:
        '<b>Tu préstamo ya está aprobado</b>. Puedes continuar para ayudarnos a mejorar nuestra toma de decisiones. De forma inmediata y 100% segura',
    },
    rejected: {
      bullet1:
        'Puedes continuar para ayudarnos a mejorar nuestra toma de decisiones. De forma inmediata y 100% segura',
    },
    bullet2:
      'Deberás estar dado de alta en el sistema Cl@ve de la Seguridad Social',
    submitBtn: 'conectar con la seg. social',
    footer:
      'VIVUS recibirá y tratará tu información referente a la Seguridad Social extraida y transferida por un proveedor externo. <privacy>Ver Política de Privacidad de VIVUS</privacy>',
    thankyou: 'No, gracias',
  },
  legalTermsModal: {
    legal_terms: 'Información sobre el préstamo',
  },
  gtmWidgets: {
    cookies: 'Política de cookies',
    accessibility: 'Accesibilidad',
  },
};

export default es;
